/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 * 
* First we will load all of this project's JavaScript dependencies which
* includes Vue and other libraries. It is a great starting point when
* building robust, powerful web applications using Vue and Laravel.
* 
*/
import '@babel/polyfill';
import './bootstrap';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import TerminMap from './components/TerminMap.vue';
import Termin from './components/Termin.vue';
import Whitepaper from './components/Whitepaper.vue';

Vue.use(Vuelidate)
// Vue.use(VueReCaptcha, { siteKey: '6LePtsEZAAAAAByhVC6TP5NErU7526KYZdgzHCK4' })

let app = new Vue({
    components: {
        TerminMap,
        Termin,
        Whitepaper
    },
}).$mount('#app');